import React from "react";
import InvoiceDiscountsSection from "./InvoiceDiscountsSection";
import InvoiceFeesSection from "./InvoiceFeesSection";
import formatCurrency from "../../../../../../../../utils/helpers/formatCurrency";

export default function ItemizedTableComp({ invoiceDetails }) {
  return (
    <div>
      {" "}
      <table className="table !tw-text-black">
        <tr className="">
          <th style={{ width: "20px" }}>#</th>
          <th style={{ textAlign: "center", width: "200px" }}>ITEM</th>
          <th style={{ textAlign: "center", width: "100px" }}>UNIT PRICE</th>
          <th style={{ textAlign: "center", width: "100px" }}>QTY</th>

          <th style={{ textAlign: "center", width: "100px" }}>AMOUNT</th>
        </tr>

        {invoiceDetails.lineItems?.map((item, index) => {
          return (
            <tr>
              <td>{index + 1}</td>
              <td style={{ textAlign: "center" }}>{item.name}</td>
              <td className="tw-text-center">{item.amount / item.quantity}</td>
              <td style={{ textAlign: "center" }}>{item.quantity}</td>
              <td style={{ textAlign: "center", paddingRight: "20px" }}>
                N{item.amount}
              </td>
            </tr>
          );
        })}

        <tr style={{ border: "0px solid #fff", backgroundColor: "#fff" }}>
          <td style={{ border: "0px solid #fff" }}></td>
          <td style={{ border: "0px solid #fff" }}></td>
          <td style={{ border: "0px solid #fff" }}></td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              border: "0px solid #fff",
            }}
          >
            Sub-Total
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              paddingRight: "20px",
            }}
          >
            
            {formatCurrency(invoiceDetails.lineItems?.reduce(
              (acc, curr) => acc + curr.amount,
              0
            ))}
          </td>
        </tr>
      </table>
      {/* <!--  Discount section  --> */}
      {invoiceDetails.discounts
        ? Boolean(invoiceDetails.discounts.length)  && <InvoiceDiscountsSection invoiceDetails={invoiceDetails}/>
        : null}
      {/* <!--  Fees section  --> */}
      {invoiceDetails.discounts
        ? Boolean(invoiceDetails.fees.length)  && <InvoiceFeesSection invoiceDetails={invoiceDetails}/>
        : null}
      {/* <!-- Grand total --> */}
      <table className="table !tw-text-black">
        <tr style={{ border: "0px solid #fff", backgroundColor: "#fff" }}>
          <td style={{ border: "0px solid #fff" }}></td>
          <td style={{ border: "0px solid #fff" }}></td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              border: "0px solid #fff",
            }}
          >
            Total
          </td>
          <td
            style={{
              fontWeight: "bold",
              textAlign: "right",
              paddingRight: "20px",
              width: "200px",
            }}
          >
            { formatCurrency(invoiceDetails.amount)}
          </td>
        </tr>
      </table>
    </div>
  );
}
